import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

export type HorizontalAppFilterScrollDirection = 'left' | 'right';

type HorizontalAppFilterScrollArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	/** Direction of the scroll. */
	direction: HorizontalAppFilterScrollDirection;
};

/**
 * `ui scrolled horizontalAppFilter` (actionSubjectId: `searchPageHorizontalAppFilterScroll`).
 *
 * Event fired when user clicks a chevron button to scroll the horizontal app filter bar.
 */
export const onHorizontalAppFilterScroll = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	direction,
}: HorizontalAppFilterScrollArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'horizontalAppFilter',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}HorizontalAppFilterScroll`,
	action: 'scrolled',
	attributes: {
		additionalAttributes: {
			direction,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
